import React from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconPay } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { openDialog } from '../../../base/dialog/actions';
//@ts-ignore
import AskingToPayDialog from '../../../pay-service-charge/components/AskingToPayDialog';
import { createRemoteVideoMenuButtonEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
const PayButton = ({ t, participantID }) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        sendAnalytics(createRemoteVideoMenuButtonEvent('Pay.button', {
            participant_id: participantID,
        }));
        dispatch(openDialog(AskingToPayDialog, { participantID }));
    };
    return (React.createElement(ContextMenuItem, { accessibilityLabel: t('videothumbnail.pay'), className: "kicklink", icon: IconPay, onClick: handleClick, text: t('videothumbnail.pay') }));
};
export default translate(PayButton);
